import { Box, Heading, Icon, Tooltip } from "@chakra-ui/react";
import _ from "lodash";
import FilterForm from "../../../components/FilterForm";
import OrganizationLiveDashboardReport from "../../../components/organization/reports/realtime/OrganizationLiveDashboard";
import { Helmet } from "react-helmet";
import { Info } from "lucide-react";
import { getReportDescription } from "../../../store/helpers";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";

const OrganizationLiveDashboard = ({
  showFilterForm = false,
  reportIndex = 1,
}) => {
  const reportTitle = `Dashboard`;
  const { reportRange, workDay } = useSelector((state) => state.defaultReducer);
  return (
    <Box>
      <Helmet>
        <title>{reportTitle}</title>
      </Helmet>
      {showFilterForm ? <FilterForm /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange).OrganizationLiveDashboard}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <OrganizationLiveDashboardReport reportIndex={reportIndex} />
        )}
      </>
    </Box>
  );
};

export default OrganizationLiveDashboard;
